import { ActionTree } from 'vuex';
import { RootState } from '@/store/types';
import { OnboardingState, PhoneNumber } from './types';
import { getSuggestedNumbers } from '@/api';
import { getRealFromVanity } from '@/utils/numbers';

const actions: ActionTree<OnboardingState, RootState> = {
  async setSuggestedNumbers({ commit }, params) {
    commit('SET_NUMBER_SEARCH_ERROR', '');
    try {
      const { key, areaCode, type, showRandomIfError } = params;
      const realNum = getRealFromVanity(key);
      const res: any = type === 'tollfree' ? await getSuggestedNumbers(0, key) : await getSuggestedNumbers(areaCode, '');

      const { phone_numbers } = res.data.available_phone_numbers;
      const filteredNumbers = phone_numbers.map((n: any) => n.phone_number);
      if (filteredNumbers.length) {
        if (type === 'tollfree') {
          let temp = {
            located: filteredNumbers[0].indexOf(realNum),
            value: filteredNumbers[0],
            index: 0
          };
          for (let i = 1; i < filteredNumbers.length; i++) {
            if (filteredNumbers[i].indexOf(realNum) < temp.located) {
              temp = {
                located: filteredNumbers[i].indexOf(realNum),
                value: filteredNumbers[i],
                index: i
              };
            }
          }
          filteredNumbers.splice(temp.index, 1);
          commit('SET_ONE_SUGGESTED_NUMBER', temp.value);
          commit('SET_SUGGESTED_NUMBERS', filteredNumbers);
        } else {
          commit('SET_ONE_SUGGESTED_NUMBER', filteredNumbers[0]);
          filteredNumbers.splice(0, 1);
          commit('SET_SUGGESTED_NUMBERS', filteredNumbers);
        }
        commit('SET_BATCH_INDEX', 0);
      } else {
        if (type === 'tollfree') {
          commit(
            'SET_NUMBER_SEARCH_ERROR',
            `Unfortunately all toll free numbers containing
              “${key}” (${realNum}) are already taken. Try updating or
              shortening your search.`
          );
          if (showRandomIfError) {
            commit('SET_SUGGESTED_NUMBERS', ''); // randomNumbers -> FIX
            commit('SET_ONE_SUGGESTED_NUMBER', '');
            commit('SET_BATCH_INDEX', 0);
          }
        } else {
          commit(
            'SET_NUMBER_SEARCH_ERROR',
            `Rats! All the phone numbers with area code
                ${areaCode} are already taken. Try changing your search.`
          );
          commit('SET_ONE_SUGGESTED_NUMBER', '');
          commit('SET_BATCH_INDEX', 0);
        }
      }
    } catch (error) {
      console.log(error);
      commit('SET_NUMBER_SEARCH_ERROR', 'Something went wrong. Please try again.');
    }
    return true;
  },
  setBatchIndex({ commit, state }) {
    if ((state.batchIndex + 1) * 8 < state.suggestedNumbers.length) {
      commit('SET_BATCH_INDEX', state.batchIndex + 1);
    } else {
      commit('SET_BATCH_INDEX', 0);
    }
  },
  setSelectedNumber({ commit }, params) {
    commit('SET_SELECTED_NUMBER', params);
  },
  setNumberObject({ commit }, params) {
    commit('SET_SELECTED_NUMBER_OBJECT', params);
  },
  setCallFlow({ commit }, params) {
    commit('UPDATE_SELECTED_NUMBER_OBJECT', { callFlow: params });
  },
  setTextFlow({ commit }, params) {
    commit('UPDATE_SELECTED_NUMBER_OBJECT', { textFlow: params });
  },
  setOnboardingStep({ commit }, params) {
    commit('SET_ONBOARDING_STEP', params);
  }
};

export default actions;
